module.exports = __webpack_public_path__ + "img/callout-dots-right.658f1c7d.png";